import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './BluePage.module.css';
import BalanceTop from '../BalanceTop/BalanceTop';
import { useBluePageStore } from '../../store/BluePageStore';
import confetti from 'canvas-confetti';
import bluePageImage from '../../assets/mockImg.png';
import Reward from '../Reward/Reward';

const BluePage = () => {
  const setOpen = useBluePageStore((state) => state.setOpen);
  const onClose = useBluePageStore((state) => state.onClose);
  const onClaimOnBoxModal = useBluePageStore(
    (state) => state.onClaimOnBoxModal,
  );
  const open = useBluePageStore((state) => state.open);
  const [visible, setVisible] = useState(open);
  const rewards = useBluePageStore((state) => state.rewards);
  const title = useBluePageStore((state) => state.title);
  const description = useBluePageStore((state) => state.description);

  useEffect(() => {
    if (open) setVisible(true);
  }, [open]);

  const handleClaim = () => {
    setVisible(false);
    setTimeout(() => {
      setOpen(false);
      onClose();
      onClaimOnBoxModal();
    }, 400);
  };

  const handleTrigger = () => {
    const end = Date.now() + 3 * 1000;
    const colors = ['#a786ff', '#fd8bbc', '#eca184', '#f8deb1'];

    const frame = () => {
      if (Date.now() > end) return;

      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        startVelocity: 60,
        origin: { x: 0, y: 0.5 },
        colors,
        zIndex: 999999,
      });

      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        startVelocity: 60,
        origin: { x: 1, y: 0.5 },
        colors,
        zIndex: 999999,
      });

      requestAnimationFrame(frame);
    };

    frame();
  };

  useEffect(() => {
    handleTrigger();
  }, []);

  // Гарантируем верхний слой BluePage на iOS: ставим класс на body
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const className = 'blue-page-open';
    if (visible) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
    return () => {
      document.body.classList.remove(className);
    };
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={styles.container}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
        >
          <BalanceTop />

          {/* Фоновый текст */}
          <div className={styles.backgroundText}>
            <div className={`${styles.backgroundRow} ${styles.row1}`}>
              BeastGifts BeastGifts BeastGifts BeastGifts BeastGifts
            </div>
            <div className={`${styles.backgroundRow} ${styles.row2}`}>
              BeastGifts BeastGifts BeastGifts BeastGifts BeastGifts
            </div>
            <div className={`${styles.backgroundRow} ${styles.row3}`}>
              BeastGifts BeastGifts BeastGifts BeastGifts BeastGifts
            </div>
          </div>

          <div className={styles.content}>
            <div className={styles.contentContainer}>
              <div className={styles.bluePageImageContainer}>
                <img
                  src={bluePageImage}
                  alt="blue page image"
                  className={styles.bluePageImage}
                />
              </div>
              <div>
                {rewards.map((reward) => (
                  <Reward
                    key={reward.id}
                    reward={reward.quantity}
                    size="large"
                    type="star"
                  />
                ))}
              </div>
              <div className={styles.title}>{title}</div>
              <div className={styles.description}>{description}</div>
            </div>
            <div className={styles.buttonContainer}>
              <button onClick={handleClaim} className={styles.button}>
                Забрать награду
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BluePage;
